<template>
  <div class="pc-hub-page">
    <!-- ===================== Hero Header ===================== -->
    <div class="pc-hero">
      <div class="pc-hero__blob pc-hero__blob--one" />
      <div class="pc-hero__blob pc-hero__blob--two" />

      <div class="pc-hero__content">
        <div class="pc-hero__icon">
          <feather-icon
            icon="LayersIcon"
            size="30"
          />
        </div>
        <div>
          <h2 class="pc-hero__title">
            Products &amp; Certificates
          </h2>
          <p class="pc-hero__subtitle">
            Explore the relationship between your products and certificates from either direction.
          </p>
        </div>
      </div>
    </div>

    <!-- ===================== Navigation cards ===================== -->
    <b-row class="match-height pc-nav-grid">
      <b-col
        cols="12"
        md="6"
      >
        <div
          class="pc-nav-card"
          role="button"
          tabindex="0"
          @click="goTo('certificate-product')"
          @keyup.enter="goTo('certificate-product')"
        >
          <span class="pc-nav-card__glow" />

          <div
            class="pc-nav-card__icon"
            :style="{ background: gradients.certificates }"
          >
            <feather-icon
              icon="AwardIcon"
              size="30"
            />
          </div>

          <h4 class="pc-nav-card__title">
            Certificates
          </h4>
          <p class="pc-nav-card__text">
            View certificates along with their corresponding products.
          </p>

          <span
            class="pc-nav-card__cta"
            :style="{ color: gradients.certificatesSolid }"
          >
            Browse certificates
            <feather-icon
              icon="ArrowRightIcon"
              size="16"
              class="ml-50 pc-nav-card__arrow"
            />
          </span>
        </div>
      </b-col>

      <b-col
        cols="12"
        md="6"
      >
        <div
          class="pc-nav-card"
          role="button"
          tabindex="0"
          @click="goTo('product-certificate')"
          @keyup.enter="goTo('product-certificate')"
        >
          <span class="pc-nav-card__glow" />

          <div
            class="pc-nav-card__icon"
            :style="{ background: gradients.products }"
          >
            <feather-icon
              icon="PackageIcon"
              size="30"
            />
          </div>

          <h4 class="pc-nav-card__title">
            Products
          </h4>
          <p class="pc-nav-card__text">
            View products and the certificates they belong to.
          </p>

          <span
            class="pc-nav-card__cta"
            :style="{ color: gradients.productsSolid }"
          >
            Browse products
            <feather-icon
              icon="ArrowRightIcon"
              size="16"
              class="ml-50 pc-nav-card__arrow"
            />
          </span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      gradients: {
        certificates: 'linear-gradient(135deg, #7367f0, #9e95f5)',
        certificatesSolid: '#7367f0',
        products: 'linear-gradient(135deg, #ff9f43, #ffbc7d)',
        productsSolid: '#ff9f43',
      },
    }
  },
  methods: {
    goTo(name) {
      this.$router.push({ name })
    },
  },
}
</script>

<style lang="scss" scoped src="./ProAndCer.scss"></style>
